import { SWEEP_SPEED } from './pulseModel.js';

// Sample from elapsed time instead of accumulating frame-dependent pixel steps.
// Each instance owns its display; resize and remount cannot retain stale history.
class Monitor {
  constructor({ sample, color, sampleStep = 1 }) {
    this.sample = sample;
    this.color = color;
    this.sampleStep = sampleStep;
  }

  plot(context, width, height, seconds) {
    context.clearRect(0, 0, width, height);
    context.strokeStyle = `rgb(${this.color.join(',')})`;

    const head = (seconds * SWEEP_SPEED) % width;
    const eraseWidth = Math.min(12, width / 10);
    context.lineWidth = 1.5;
    context.lineJoin = 'round';
    context.lineCap = 'round';
    let previous = null;

    for (let x = 1; x < width - 1; x += this.sampleStep) {
      const age = (head - x + width) % width;
      if (age > width - eraseWidth) {
        previous = null;
        continue;
      }
      const time = seconds - age / SWEEP_SPEED;
      const y = this.sample(time);
      if (previous) {
        context.globalAlpha = 0.35 + 0.65 * (1 - age / width);
        context.beginPath();
        context.moveTo(previous.x, previous.y);
        context.lineTo(x, y);
        context.stroke();
      }
      previous = { x, y };
    }
    context.globalAlpha = 1;
  }
}

export default Monitor;
